import { useEffect, useState } from 'react'
import { i18n } from '@fs/zion-locale'
import { useQuery } from '@apollo/client'
import queries from './queries'

const UPDATE_FREQUENCY_MILLI = 250

export default function useImageCount() {
  const countFormat = new Intl.NumberFormat(i18n.language || navigator.language)

  const [currentCount, setCurrentCount] = useState(() => 0)
  const { data, error, loading } = useQuery(queries.imageTotal, {
    errorPolicy: 'all',
  })

  // Use a separate useEffect to initialize the count
  useEffect(() => {
    if (!error && !loading && data?.imageTotal) {
      const initialCount = Math.trunc(data?.imageTotal?.start)
      setCurrentCount(initialCount)
    }
  }, [data, error, loading])

  useEffect(() => {
    let interval

    if (!error && !loading && data?.imageTotal) {
      interval = setInterval(() => {
        const deltaPerMilli = Number(data?.imageTotal?.deltaPerMilli) || 0
        const newCount = currentCount + deltaPerMilli * UPDATE_FREQUENCY_MILLI
        setCurrentCount(newCount)
      }, UPDATE_FREQUENCY_MILLI)
    }

    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [currentCount, data, error, loading])

  return countFormat.format(Math.trunc(currentCount))
}
